import { render } from "./BranchedTree.vue?vue&type=template&id=6a3bdd33&scoped=true"
import script from "./BranchedTree.vue?vue&type=script&lang=js"
export * from "./BranchedTree.vue?vue&type=script&lang=js"

import "./BranchedTree.vue?vue&type=style&index=0&id=6a3bdd33&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3bdd33"]])

export default __exports__